import { render, staticRenderFns } from "./ModalAtalhos.vue?vue&type=template&id=28fcb72e&"
import script from "./ModalAtalhos.vue?vue&type=script&lang=js&"
export * from "./ModalAtalhos.vue?vue&type=script&lang=js&"
import style0 from "./ModalAtalhos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports